import { RadioGroupItem } from 'src/shared/components/ui'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { useOrganizationCurrency } from 'src/shared/hooks/useOrganizationCurrency'
import { Badge } from 'src/shared/components/ui/badge'

const cardStyles = {
  base: 'relative p-4 rounded-lg border-2 h-fit',
  interactive: 'cursor-pointer',
  selected:
    'border-blue-500 bg-gradient-to-br from-blue-50/70 via-blue-100/70 to-blue-200/80',
  unselected:
    'border-gray-200 bg-gradient-to-br from-white via-gray-50 to-gray-100 hover:border-gray-300',
}

const radioStyles = {
  selected: 'border-blue-500 text-blue-500',
  unselected: 'border-gray-300 text-gray-400',
}

export const DecorationCard = ({
  decoration,
  isSelected,
  quoteSubItem,
  readonly = false,
}) => {
  const { t } = useLocalization()
  const currency = useOrganizationCurrency()
  const cardClass = cn(
    cardStyles.base,
    !readonly && cardStyles.interactive,
    isSelected ? cardStyles.selected : cardStyles.unselected
  )
  const radioClass = isSelected ? radioStyles.selected : radioStyles.unselected
  const textName = isSelected ? 'text-black' : 'text-black'
  const textColors = isSelected ? 'text-blue-600' : 'text-gray-500'
  const textOneLiner = isSelected ? 'text-gray-600' : 'text-gray-500'

  const content = (
    <Column className="gap-2">
      <Row className="justify-between items-start">
        <Row className="items-center gap-2">
          <span className={textName}>{t(decoration?.info?.name)}</span>

          {quoteSubItem?.d_colors > 0 && (
            <Badge>
              <p className={cn('text-xs', textColors)}>
                {quoteSubItem?.d_colors}{' '}
                {quoteSubItem?.d_colors === 1
                  ? t('color', 'färg')
                  : t('colors', 'färger')}
              </p>
            </Badge>
          )}
        </Row>

        {!readonly && (
          <RadioGroupItem
            value={decoration?.print_code}
            id={decoration?.print_code}
            className={radioClass}
          />
        )}
      </Row>

      {decoration?.info?.one_liner && (
        <p className={cn('text-xs', textOneLiner)}>
          {t(decoration?.info?.one_liner)}
        </p>
      )}

      <p className="text-sm font-normal text-gray-900">
        {decoration?.unit_cost
          ? Math.round(decoration?.unit_cost).toLocaleString('sv-SE')
          : 0}{' '}
        {currency} / {t('unit', 'enhet')}
      </p>

      <p className="text-xs text-gray-600">
        {decoration?.setup_cost > 0 ? (
          <>
            +{decoration?.setup_cost} {currency} {t('setup', 'setupkostnad')}
          </>
        ) : (
          <>{t('No setup cost', 'Ingen setup-kostnad')}</>
        )}
      </p>
    </Column>
  )

  if (readonly) {
    return <div className={cardClass}>{content}</div>
  }

  return <label className={cardClass}>{content}</label>
}
